import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _, { chain, partial, split } from 'lodash';

import { PATH } from '../../../../constants/path';
import { STATIC_ROOT, BRAND_NAME } from '../../../../constants';

import SvgComponent from '../../../SvgComponent';
import { HeadComponent } from '../../../HeadComponent';
import LocalizedNavLink from '../../../router/LocalizedNavLink';

import './ConfirmationKycPage.scss';

const ConfirmationKycPage = ({ i18n, event }) => {
    const [status, setStatus] = useState('COMPLETED');

    useEffect(() => {
        getKycStatus();
        setTimeout(() => window.close(), 10000);
    }, []);

    const getKycStatus = () => {
        if (!event) {
            setStatus('REFUSAL');
        } else if (event.includes('identity_verification_capture_completed')) {
            setStatus('COMPLETED');
        } else if (event.includes('identity_verification_capture_aborted')) {
            setStatus('ABORTION');
        } else if (event.includes('identity_verification_capture_refused')) {
            setStatus('REFUSAL');
        } else {
            setStatus('EXPIRATION');
        }
    };

    const { TITLE, DETAILS } = i18n[status];

    return (
        <div className="template template-primary flex-container-v">
            <div className="entete minimal" id="entete">
                <div className="flex-container-v">
                    <header className="tetedepage conteneur flex-container-h flex-center-alt">
                        <LocalizedNavLink to={PATH.HOME_PATH} title={BRAND_NAME} className="logo">
                            <img
                                src={`${STATIC_ROOT}/logo.png`}
                                alt={BRAND_NAME}
                                width="130"
                                height="53"
                            />
                        </LocalizedNavLink>
                    </header>
                </div>
            </div>
            <main id="p-ebon-confirmation-kyc" className="conteneur conteneur-mobile">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />

                <div>
                    <SvgComponent
                        src={`${STATIC_ROOT}/kyc/${
                            status === 'COMPLETED' ? 'success' : 'cross-circled'
                        }.svg`}
                        width="65"
                        height="65"
                        alt="statut KYC"
                    />
                    <p className="title">{TITLE}</p>
                    <p>{DETAILS}</p>
                </div>
            </main>
        </div>
    );
};

ConfirmationKycPage.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
    const search = ownProps.location.search;
    const params =
        search &&
        chain(search)
            .replace('?', '') // a=toto
            .split('&') // ["a=toto","c=bobo","f=coco"]
            .map(partial(split, _, '=', 2)) // [["a","toto"],["c","bobo"],["f","coco"]]
            .fromPairs() // {"a":"toto","c":"bobo","f":"coco"}
            .value();
    const event = params.event;

    return {
        i18n: state.i18n.page.EBON.KYC.CONFIRMATION_PAGE,
        event: event
    };
};

export default withRouter(connect(mapStateToProps)(ConfirmationKycPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/kyc/ConfirmationKycPage.js